import { showNotification } from '@mantine/notifications';
import { useEffect, useState } from 'react';
import { X } from 'tabler-icons-react';
import AdminEntityManager from '../../components/admin-entities/admin-entity-manager/admin-entity-manager.component';
import { Entity } from '../../enums/entity.enums';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useDidMountEffect from '../../hooks/useDidMountEffect';
import { IPaginationMeta } from '../../type/admin.types';
import {
  BasicReseller,
  RetrieveAllEntityRequest,
  RetrieveAllResellersResponse,
} from '../../type/entity.types';
import { ErrorResponse } from '../../type/error-response.types';

function AdminResellersPage() {
  const axiosPrivate = useAxiosPrivate();
  const [resellersData, setResellersData] = useState<BasicReseller[]>();
  const [paginationData, setPaginationData] = useState<IPaginationMeta>();
  const [loadResellersParams, setLoadResellersParams] =
    useState<RetrieveAllEntityRequest>({
      page: 1,
      limit: 20,
    });
  const [refreshTable, setRefreshTable] = useState(false);
  const [checkedAll, setCheckedAll] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadResellers = async () => {
    let params: LoadResellersName = {
      ...loadResellersParams,
    };

    //rename search entity to its correct name
    delete params.searchEntity;
    if (loadResellersParams.searchEntity?.trim()) {
      params.resellerName = loadResellersParams.searchEntity;
    } else {
      delete params.resellerName;
    }

    try {
      setIsLoading(true);
      const response = await axiosPrivate.get('web/resellers', {
        params,
      });

      const data: RetrieveAllResellersResponse = response.data;
      const resellers: BasicReseller[] = data?.items;

      setPaginationData(data?.metadata);
      return resellers;
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;

      showNotification({
        id: 'failed-to-load-resellers-data',
        message:
          error.error || err?.response?.data || 'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const paginationRequest = (page: number, limit: number) => {
    setLoadResellersParams((prev) => {
      return {
        ...prev,
        page,
        limit,
      };
    });
  };

  const loadAndSetResellers = async () => {
    const resellers = await loadResellers();
    setResellersData(resellers);
  };

  useDidMountEffect(() => {
    loadAndSetResellers();
    setCheckedAll(false);
    setIsChecked([]);
  }, [loadResellersParams]);

  useDidMountEffect(() => {
    loadAndSetResellers();
  }, [refreshTable]);

  useEffect(() => {
    loadAndSetResellers();
  }, []);

  return (
    <>
      <AdminEntityManager
        entityType={Entity.RESELLER}
        resellersData={resellersData}
        paginationRequest={paginationRequest}
        paginationData={paginationData}
        entityParams={loadResellersParams}
        setEntityParams={setLoadResellersParams}
        setRefreshTable={setRefreshTable}
        checkedAll={checkedAll}
        setCheckedAll={setCheckedAll}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
        isLoading={isLoading}
      />
    </>
  );
}

export default AdminResellersPage;

interface LoadResellersName extends RetrieveAllEntityRequest {
  resellerName?: string;
}
